import { Flex, Typography } from 'antd';
import { FilterBarAddButton } from '~/app/components/common/FilterBar/FilterBarToolbar';
import type { ReactNode } from 'react';

const { Title, Text } = Typography;

type Props = {
  title: string;
  subtitle: string;
  addLabel: string;
  onAdd: () => void;
  icon?: ReactNode;
  canAdd?: boolean;
};

export function SlaPageHeader({
  title,
  subtitle,
  addLabel,
  onAdd,
  icon,
  canAdd = false,
}: Props) {
  return (
    <Flex
      className="sla-page-header"
      justify="space-between"
      align="flex-start"
      gap={16}
      wrap="wrap"
    >
      <Flex align="flex-start" gap={14} className="app-page-header-left">
        {icon ? <div className="sla-page-header__icon">{icon}</div> : null}
        <div>
          <Title level={2} className="ds-page-title" style={{ margin: 0 }}>
            {title}
          </Title>
          <Text type="secondary" className="om-dashboard-header__subtitle">
            {subtitle}
          </Text>
        </div>
      </Flex>
      {canAdd ? <FilterBarAddButton label={addLabel} onClick={onAdd} /> : null}
    </Flex>
  );
}
